import React from 'react';
import { useTranslation } from 'react-i18next';
import { ModalInformation } from '@panel/commons/lib/Modals/ModalInformation';

function PublishError(props) {
  const { onClickAction } = props;
  const { t } = useTranslation();
  return (
    <ModalInformation
      onClickAction={onClickAction}
      onClickOutside={onClickAction}
      title={t('panel.modal.PublishError.title')}
      message={t('panel.modal.PublishError.text')}
      ctaOk={t('panel.modal.cta.understood')}
    />
  );
}

export { PublishError };
